"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var ActionLabel_1 = __importDefault(require("./styledComponents/ActionLabel"));
var Icon_1 = __importDefault(require("./styledComponents/Icon"));
var Dropdown_1 = __importDefault(require("./components/Dropdown"));
var DropdownContent_1 = __importDefault(require("./styledComponents/DropdownContent"));
var DropdownItem_1 = __importDefault(require("./components/DropdownItem"));
var Translate_1 = __importDefault(require("../Translate/Translate"));
var ContextMenuPill_1 = __importDefault(require("./styledComponents/ContextMenuPill"));
var ContextMenu_meta_1 = require("./ContextMenu.meta");
var Checkbox_1 = __importDefault(require("../Checkbox"));
var EContextMenuTypes_1 = require("./models/EContextMenuTypes");
var DropdownItemWrapper_1 = __importDefault(require("./styledComponents/DropdownItemWrapper"));
var StyledLabel_1 = __importDefault(require("./styledComponents/StyledLabel"));
var Count_1 = __importDefault(require("./styledComponents/Count"));
var IconWrapper_1 = __importDefault(require("./styledComponents/IconWrapper"));
var ClearButton_1 = __importDefault(require("./styledComponents/ClearButton"));
var NAVIGATION_KEYS = [
    shared_1.KEYS.UP_ARROW,
    shared_1.KEYS.DOWN_ARROW,
    shared_1.KEYS.LEFT_ARROW,
    shared_1.KEYS.RIGHT_ARROW,
    shared_1.KEYS.PAGE_UP,
    shared_1.KEYS.PAGE_DOWN,
    shared_1.KEYS.HOME,
    shared_1.KEYS.END,
];
var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];
var EXIT_KEYS = [shared_1.KEYS.ESCAPE];
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY;
        _this.componentKey = ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY;
        _this.activeMenuType = 'menu';
        _this.subItemDropdownTopMargin = 0;
        _this.subItemReferences = [];
        _this.internalFocusedIndex = 0;
        _this.internalFocusedSubIndex = 0;
        _this.forceInternalFocus = false;
        _this.focusedButton = false;
        _this.focusElement = null;
        _this.open = false;
        _this.assignItemReference = function (reference, index) {
            if (reference && _this.itemReferences && index >= 0 && index < _this.itemReferences.length) {
                _this.itemReferences[index] = reference;
            }
        };
        _this.assignSubItemReference = function (reference, index) {
            if (reference && _this.subItemReferences && index >= 0 && index < _this.subItemReferences.length) {
                _this.subItemReferences[index] = reference;
            }
        };
        _this.focusItemIndex = function () {
            if (_this.itemReferences && _this.itemReferences[_this.internalFocusedIndex] !== undefined) {
                var reference = _this.itemReferences[_this.internalFocusedIndex];
                _this.setSubItemDropdownTopMargin(reference);
                reference.focus();
            }
        };
        _this.focusSubItemIndex = function () {
            if (_this.subItemReferences && _this.subItemReferences[_this.internalFocusedSubIndex] !== undefined) {
                _this.subItemReferences[_this.internalFocusedSubIndex].focus();
            }
        };
        _this.toggleDropdown = function () {
            _this.open = !_this.open;
            _this.removeFocusElement();
            var onToggleDropdown = _this.props.onToggleDropdown;
            if (onToggleDropdown) {
                onToggleDropdown(_this.open);
            }
            if (_this.open) {
                _this.forceInternalFocus = true;
            }
        };
        _this.handleActionSelection = function (action) {
            if (action) {
                var payload = _this.props.payload;
                var onClick = action.onClick;
                if (onClick) {
                    onClick(payload);
                }
            }
        };
        _this.handleChildSelection = function (event, itemIndex) {
            var onChildSelection = _this.props.onChildSelection;
            if (onChildSelection) {
                onChildSelection(event, itemIndex);
            }
        };
        _this.handleSelection = function (event, itemIndex, action, mappingKey, mappingSubKey) {
            event.stopPropagation();
            var _a = _this.props, isMultiSelect = _a.isMultiSelect, filterOptions = _a.filterOptions;
            if (_this.activeMenuType === 'menu') {
                if (itemIndex !== undefined && _this.internalFocusedIndex !== itemIndex) {
                    _this.internalFocusedIndex = itemIndex;
                    _this.forceInternalFocus = true;
                }
            }
            if (_this.activeMenuType === 'sub-menu') {
                if (itemIndex !== undefined && _this.internalFocusedSubIndex !== itemIndex) {
                    _this.internalFocusedSubIndex = itemIndex;
                    _this.forceInternalFocus = true;
                }
            }
            if (action) {
                _this.handleActionSelection(action);
            }
            else if (_this.type === 'filter' && mappingKey && filterOptions) {
                filterOptions.toggleFilterCheckbox(mappingKey, mappingSubKey);
            }
            else if (itemIndex !== undefined) {
                _this.handleChildSelection(event, itemIndex);
            }
            if (!isMultiSelect) {
                _this.open = false;
                _this.focusedButton = true;
            }
        };
        _this.handleLeftRightNavigation = function (key) {
            if (key === shared_1.KEYS.RIGHT_ARROW && _this.activeMenuType === 'menu' && _this.filterSubMapping) {
                _this.activeMenuType = 'sub-menu';
            }
            if (key === shared_1.KEYS.LEFT_ARROW && _this.activeMenuType === 'sub-menu') {
                _this.activeMenuType = 'menu';
                _this.internalFocusedSubIndex = 0;
            }
        };
        _this.onOpenNavigation = function (key) {
            var _a = _this.props.pageKeyTraverseSize, pageKeyTraverseSize = _a === void 0 ? 3 : _a;
            // leftArrow and rightArrow navigation to switch between menu or sub-menu
            _this.handleLeftRightNavigation(key);
            var itemReferenceLength = _this.itemReferences.length - 1;
            var subItemReferenceLength = _this.subItemReferences.length - 1;
            var isSubMenuType = _this.activeMenuType === 'sub-menu';
            var lastIndex = isSubMenuType ? subItemReferenceLength : itemReferenceLength;
            var nextIndex = isSubMenuType ? _this.internalFocusedSubIndex : _this.internalFocusedIndex;
            switch (key) {
                case shared_1.KEYS.UP_ARROW:
                    nextIndex -= 1;
                    break;
                case shared_1.KEYS.DOWN_ARROW:
                    nextIndex += 1;
                    break;
                case shared_1.KEYS.PAGE_UP:
                    var pageUp = nextIndex - pageKeyTraverseSize;
                    nextIndex = nextIndex > 0 && pageUp < 0 ? 0 : pageUp;
                    break;
                case shared_1.KEYS.PAGE_DOWN:
                    var pageDown = nextIndex + pageKeyTraverseSize;
                    nextIndex = nextIndex < lastIndex && pageDown > lastIndex ? 0 : pageDown;
                    break;
                case shared_1.KEYS.HOME:
                    nextIndex = 0;
                    break;
                case shared_1.KEYS.END:
                    nextIndex = lastIndex;
                    break;
                default:
                    break;
            }
            if (nextIndex < 0) {
                nextIndex = lastIndex;
            }
            if (nextIndex > lastIndex) {
                nextIndex = 0;
            }
            if (isSubMenuType) {
                _this.internalFocusedSubIndex = nextIndex;
                _this.focusSubItemIndex();
            }
            else {
                _this.internalFocusedIndex = nextIndex;
                _this.focusItemIndex();
            }
        };
        _this.onClosedNavigation = function (key) {
            switch (key) {
                case shared_1.KEYS.UP_ARROW:
                case shared_1.KEYS.DOWN_ARROW:
                    _this.toggleDropdown();
                    break;
                default:
                    break;
            }
        };
        _this.handleKeyUp = function (event, key, index) {
            _this.setFocusElement(key, index);
        };
        _this.handleKeyDown = function (event, itemIndex, action, mappingKey, mappingSubKey) {
            var key = event.key;
            var isNavEvent = NAVIGATION_KEYS.indexOf(key) !== -1;
            var isAcceptEvent = ACCEPT_KEYS.indexOf(key) !== -1;
            var isExitEvent = EXIT_KEYS.indexOf(key) !== -1;
            if (key !== shared_1.KEYS.TAB && (isNavEvent || isAcceptEvent || isExitEvent)) {
                event.preventDefault();
                if (isNavEvent) {
                    event.stopPropagation();
                }
            }
            if (_this.open) {
                if (key === shared_1.KEYS.TAB) {
                    // Leave Commented to allow tab key within context menu so that the item can navigate grouped content
                    // this.toggleDropdown();
                }
                else if (isNavEvent) {
                    _this.onOpenNavigation(key);
                }
                else if (isExitEvent) {
                    _this.toggleDropdown();
                    _this.focusedButton = true;
                }
                else if (isAcceptEvent && _this.itemReferences.length > 0 && _this.internalFocusedIndex >= 0) {
                    _this.handleSelection(event, itemIndex, action, mappingKey, mappingSubKey);
                }
            }
            else {
                if (isNavEvent) {
                    _this.onClosedNavigation(key);
                }
                else if (isAcceptEvent) {
                    _this.toggleDropdown();
                }
            }
        };
        _this.appendIsFocus = function (props, itemIndex) {
            // tslint:disable-next-line: no-this-assignment
            var _a = _this, forceInternalFocus = _a.forceInternalFocus, internalFocusedIndex = _a.internalFocusedIndex;
            var focusedIndexFromProps = _this.props.focusedIndex;
            var isPropFocused = focusedIndexFromProps === itemIndex;
            var isInternallyFocused = focusedIndexFromProps === undefined && forceInternalFocus && internalFocusedIndex === itemIndex;
            if (isPropFocused || isInternallyFocused) {
                props.isFocused = true;
                _this.forceInternalFocus = false;
            }
            return props;
        };
        _this.setFocusElement = function (key, index) {
            var reference = _this.itemReferences[index];
            _this.setSubItemDropdownTopMargin(reference);
            _this.focusElement = key;
        };
        _this.removeFocusElement = function () {
            _this.focusElement = null;
        };
        _this.setSubItemDropdownTopMargin = function (reference) {
            if (reference) {
                _this.subItemDropdownTopMargin = reference.offsetTop || 0;
            }
        };
        _this.shouldInternalFocusUpdate(props);
        // tslint:disable-next-line: no-this-assignment
        var _a = _this, hasActions = _a.hasActions, actions = _a.actions, hasChildren = _a.hasChildren, children = _a.children, type = _a.type;
        var filterOptions = props.filterOptions;
        var itemListLength = 0;
        if (type === EContextMenuTypes_1.EContextMenuTypes.actions && hasActions) {
            itemListLength = actions.length;
        }
        else if (type === EContextMenuTypes_1.EContextMenuTypes.children && hasChildren) {
            itemListLength = children.length;
        }
        else if (type === EContextMenuTypes_1.EContextMenuTypes.filter && filterOptions && filterOptions.filterMapping) {
            itemListLength = filterOptions.filterMapping.length;
            if (filterOptions && !filterOptions.hideClearFilters) {
                // Adding a additional item in the array for keyboard support to work with the clear button
                itemListLength++;
            }
        }
        _this.itemReferences = new Array(itemListLength);
        return _this;
    }
    ContextMenu.prototype.componentDidUpdate = function () {
        this.shouldInternalFocusUpdate(this.props);
    };
    ContextMenu.prototype.shouldInternalFocusUpdate = function (props) {
        var focusedIndex = props.focusedIndex;
        if (focusedIndex !== undefined) {
            this.internalFocusedIndex = focusedIndex;
        }
    };
    Object.defineProperty(ContextMenu.prototype, "filterMapping", {
        get: function () {
            var filterOptions = this.props.filterOptions;
            if (filterOptions && filterOptions.filterMapping) {
                return filterOptions.filterMapping.filter(function (mapping) { return mapping.visible; });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "actions", {
        get: function () {
            var _a = this.props, actions = _a.actions, payload = _a.payload;
            if (actions && actions.length > 0) {
                return actions.filter(function (action) { return !action.visible || action.visible(payload); });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "hasActions", {
        get: function () {
            // tslint:disable-next-line: no-this-assignment
            var actions = this.actions;
            return actions && actions.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "type", {
        get: function () {
            var type = this.props.type;
            return type || 'children';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "filterSubMapping", {
        get: function () {
            var _this = this;
            var filterOptions = this.props.filterOptions;
            if (this.filterMapping && this.focusElement) {
                var filterMapping = this.filterMapping.find(function (mapping) { return mapping.key === _this.focusElement; });
                if (filterMapping && filterMapping.subMapping) {
                    var subMapping = filterMapping.subMapping.filter(function (mapping) { return mapping.visible; });
                    var itemListLength = subMapping.length;
                    if (filterOptions && !filterOptions.hideClearFilters) {
                        // Adding a additional item in the array for keyboard support to work with the clear button
                        itemListLength++;
                    }
                    this.subItemReferences = new Array(itemListLength);
                    return {
                        subMapping: subMapping,
                        _parentKey: filterMapping.key,
                    };
                }
            }
            return { subMapping: [] };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "children", {
        get: function () {
            var children = this.props.children;
            return Array.isArray(children) ? children : [children];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "hasChildren", {
        get: function () {
            // tslint:disable-next-line: no-this-assignment
            var children = this.children;
            return children && children.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "asset", {
        get: function () {
            var asset = this.open ? 'base.contextMenu.dropdownIconExpanded' : 'base.contextMenu.dropdownIcon';
            return asset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "contextMenuLabel", {
        get: function () {
            var _a = this.props, label = _a.label, labelIcon = _a.labelIcon, showPill = _a.showPill, pillProps = _a.pillProps;
            var overridingPillProps = Object.assign({}, pillProps, {
                value: label,
            });
            if (this.hasIconLabel) {
                return react_1.default.createElement(Icon_1.default, __assign({}, labelIcon));
            }
            if (showPill) {
                return react_1.default.createElement(ContextMenuPill_1.default, __assign({}, overridingPillProps));
            }
            if (typeof label === 'string') {
                return react_1.default.createElement(Translate_1.default, null, label);
            }
            return label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "hasIconLabel", {
        get: function () {
            var labelIcon = this.props.labelIcon;
            return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(labelIcon);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "buttonProps", {
        get: function () {
            var _this = this;
            var describedById = this.props.describedById;
            var props = {
                className: this.hasIconLabel ? 'base-contextMenu-button-with-icon' : '',
                'aria-describedby': describedById,
                onClick: function (event) {
                    event.stopPropagation();
                    _this.toggleDropdown();
                },
                onKeyDown: function (event) { return _this.handleKeyDown(event); },
            };
            if (this.focusedButton) {
                props.isFocused = true;
                this.focusedButton = false;
            }
            return props;
        },
        enumerable: true,
        configurable: true
    });
    ContextMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, hideAsset = _a.hideAsset, iconAlt = _a.iconAlt, filterOptions = _a.filterOptions;
        // Type `children` and `actions` are left here for backwards compatibility
        var isChildren = this.type === EContextMenuTypes_1.EContextMenuTypes.children;
        var isActions = this.type === EContextMenuTypes_1.EContextMenuTypes.actions;
        var isFilter = this.type === EContextMenuTypes_1.EContextMenuTypes.filter;
        var hideClearFilters = filterOptions && filterOptions.hideClearFilters;
        var onClearFilters = filterOptions && filterOptions.onClearFilters;
        var filterMappingLength = String(this.filterMapping.length);
        var filterSubMappingLength = String(this.filterSubMapping.subMapping.length);
        // Destructuring here to set a default on subMapping, it was causing the build to break
        var _b = this.filterSubMapping, _c = _b.subMapping, subMapping = _c === void 0 ? [] : _c, _parentKey = _b._parentKey;
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            isChildren && (react_1.default.createElement(Dropdown_1.default, { buttonProps: this.buttonProps, contextMenuLabel: this.contextMenuLabel, asset: this.asset, toggleDropdown: this.toggleDropdown, open: this.open, iconAlt: iconAlt, hideAsset: hideAsset },
                react_1.default.createElement(DropdownContent_1.default, null,
                    react_1.default.createElement(DropdownItemWrapper_1.default, { role: "list" }, this.hasChildren &&
                        this.children.map(function (item, index) {
                            var itemIsString = typeof item === 'string';
                            var content = itemIsString ? react_1.default.createElement(Translate_1.default, null, item) : item;
                            var dropdownProps = _this.appendIsFocus({}, index);
                            return (react_1.default.createElement(DropdownItem_1.default, __assign({ id: "" + index, key: "" + index, onClick: function (event) {
                                    _this.handleSelection(event, index);
                                }, onKeyDown: function (event) { return _this.handleKeyDown(event, index); }, getItemReference: function (reference) {
                                    return _this.assignItemReference(reference, index);
                                } }, dropdownProps), content));
                        }))))),
            isActions && (react_1.default.createElement(Dropdown_1.default, { buttonProps: this.buttonProps, contextMenuLabel: this.contextMenuLabel, asset: this.asset, toggleDropdown: this.toggleDropdown, open: this.open, iconAlt: iconAlt, hideAsset: hideAsset },
                react_1.default.createElement(DropdownContent_1.default, null,
                    react_1.default.createElement(DropdownItemWrapper_1.default, { role: "list" }, this.actions.map(function (action, index) {
                        var key = action.key, label = action.label;
                        var dropdownProps = _this.appendIsFocus({}, index);
                        return (react_1.default.createElement(DropdownItem_1.default, __assign({ id: key || "" + index, key: key || "" + index, onClick: function (event) {
                                _this.handleSelection(event, index, action);
                            }, onKeyDown: function (event) {
                                return _this.handleKeyDown(event, index, action);
                            }, getItemReference: function (reference) { return _this.assignItemReference(reference, index); } }, dropdownProps),
                            react_1.default.createElement(ActionLabel_1.default, null,
                                react_1.default.createElement(Translate_1.default, null, label))));
                    }))))),
            isFilter && this.filterMapping && (react_1.default.createElement(Dropdown_1.default, { buttonProps: this.buttonProps, contextMenuLabel: this.contextMenuLabel, asset: this.asset, toggleDropdown: this.toggleDropdown, open: this.open, iconAlt: iconAlt, hideAsset: hideAsset },
                react_1.default.createElement(DropdownContent_1.default, null,
                    react_1.default.createElement(DropdownItemWrapper_1.default, { role: "list" },
                        this.filterMapping.map(function (_a, index) {
                            var key = _a.key, label = _a.label, subMapping = _a.subMapping, checked = _a.checked, count = _a.count;
                            var dropdownProps = _this.appendIsFocus({}, index);
                            return (react_1.default.createElement(DropdownItem_1.default, __assign({ id: key || "" + index, key: key || "" + index, onClick: function (event) {
                                    event.preventDefault();
                                    _this.handleSelection(event, index, undefined, String(key));
                                }, onKeyDown: function (event) {
                                    return _this.handleKeyDown(event, index, undefined, String(key));
                                }, onKeyUp: function (event) {
                                    return _this.handleKeyUp(event, key, index);
                                }, onMouseEnter: function () { return _this.setFocusElement(key, index); }, getItemReference: function (reference) {
                                    return _this.assignItemReference(reference, index);
                                } }, dropdownProps),
                                react_1.default.createElement(Translate_1.default, null,
                                    react_1.default.createElement(StyledLabel_1.default, { key: key },
                                        react_1.default.createElement(Checkbox_1.default, { value: checked }),
                                        label),
                                    react_1.default.createElement(Count_1.default, null, count && " (" + count + ")"),
                                    react_1.default.createElement(IconWrapper_1.default, null, subMapping && subMapping.length > 0 ? (react_1.default.createElement(Icon_1.default, { alt: 'Context Sub-Menu Icon', asset: "base.paging.rightArrow" })) : null))));
                        }),
                        !hideClearFilters && (react_1.default.createElement(DropdownItem_1.default, { id: filterMappingLength, key: filterMappingLength, onClick: function () {
                                onClearFilters && onClearFilters();
                            }, onKeyDown: function (event) {
                                return _this.handleKeyDown(event, Number(filterMappingLength));
                            }, onKeyUp: function (event) {
                                return _this.handleKeyUp(event, filterMappingLength, Number(filterMappingLength));
                            }, onMouseEnter: function () {
                                return _this.setFocusElement(filterMappingLength, Number(filterMappingLength));
                            }, getItemReference: function (reference) {
                                return _this.assignItemReference(reference, Number(filterMappingLength));
                            } },
                            react_1.default.createElement(Translate_1.default, null,
                                react_1.default.createElement(ClearButton_1.default, null, "Clear")))))),
                subMapping && subMapping.length > 0 && (react_1.default.createElement(DropdownContent_1.default, { style: {
                        marginTop: this.subItemDropdownTopMargin + "px",
                    } },
                    react_1.default.createElement(DropdownItemWrapper_1.default, { role: "list" },
                        subMapping.map(function (_a, index) {
                            var key = _a.key, label = _a.label, checked = _a.checked, count = _a.count;
                            var dropdownProps = _this.appendIsFocus({}, index);
                            var args = [index, undefined, String(_parentKey), String(key)];
                            return (react_1.default.createElement(DropdownItem_1.default, __assign({ id: key || "" + index, key: key || "" + index, onClick: function (event) {
                                    event.preventDefault();
                                    _this.handleSelection.apply(_this, __spreadArrays([event], args));
                                }, onKeyDown: function (event) {
                                    return _this.handleKeyDown.apply(_this, __spreadArrays([event], args));
                                }, getItemReference: function (reference) {
                                    return _this.assignSubItemReference(reference, index);
                                } }, dropdownProps),
                                react_1.default.createElement(Translate_1.default, null,
                                    react_1.default.createElement(StyledLabel_1.default, { key: key },
                                        react_1.default.createElement(Checkbox_1.default, { value: checked }),
                                        label),
                                    react_1.default.createElement(Count_1.default, null, count && " (" + count + ")"))));
                        }),
                        !hideClearFilters && (react_1.default.createElement(DropdownItem_1.default, { id: filterMappingLength, key: filterMappingLength, onClick: function () {
                                onClearFilters && onClearFilters();
                            }, onKeyDown: function (event) {
                                return _this.handleKeyDown(event, Number(filterSubMappingLength));
                            }, getItemReference: function (reference) {
                                return _this.assignSubItemReference(reference, Number(filterSubMappingLength));
                            } },
                            react_1.default.createElement(Translate_1.default, null,
                                react_1.default.createElement(ClearButton_1.default, null, "Clear")))))))))));
    };
    __decorate([
        mobx_1.observable
    ], ContextMenu.prototype, "focusElement", void 0);
    __decorate([
        mobx_1.observable
    ], ContextMenu.prototype, "open", void 0);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "filterMapping", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "actions", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "hasActions", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "type", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "filterSubMapping", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "children", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "hasChildren", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "contextMenuLabel", null);
    __decorate([
        mobx_1.computed
    ], ContextMenu.prototype, "hasIconLabel", null);
    __decorate([
        mobx_1.action
    ], ContextMenu.prototype, "handleSelection", void 0);
    __decorate([
        mobx_1.action
    ], ContextMenu.prototype, "setFocusElement", void 0);
    __decorate([
        mobx_1.action
    ], ContextMenu.prototype, "removeFocusElement", void 0);
    ContextMenu = __decorate([
        mobx_react_1.observer
    ], ContextMenu);
    return ContextMenu;
}(shared_1.ComponentBase));
exports.ContextMenu = ContextMenu;
exports.default = shared_1.InjectedStyledComponent(ContextMenu, ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY, ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY);
